import React from 'react';
import { Avatar, AvatarImage, AvatarFallback } from '@frontend/shadcn/components/ui/avatar';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@frontend/shadcn/components/ui/tooltip';
import { cn } from '@frontend/shadcn/lib/utils';

interface UserAvatarProps {
  imageUrl?: string;
  name: string;
  className?: string;
}

const getInitials = (name: string) => {
  const words = name.trim().split(' ');
  const first = words[0]?.charAt(0).toUpperCase() || '';
  const second = words.length > 1 ? words[1].charAt(0).toUpperCase() : '';
  return first + second;
};

const getColorForName = (name: string) => {
  const colors = [
    'bg-red-500',
    'bg-blue-500',
    'bg-green-500',
    'bg-yellow-500',
    'bg-purple-500',
    'bg-pink-500',
    'bg-indigo-500',
    'bg-teal-500',
  ];

  const hash = name.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);

  return colors[hash % colors.length];
};

const UserAvatar: React.FC<UserAvatarProps> = ({ imageUrl, name, className }) => {
  if (!name) {
    return null;
  }

  const colorClass = getColorForName(name);

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Avatar className={cn(className, 'cursor-pointer w-8 h-8')}>
            <AvatarImage src={imageUrl} alt={name} />
            <AvatarFallback className={`text-white font-semibold ${colorClass}`}>{getInitials(name)}</AvatarFallback>
          </Avatar>
        </TooltipTrigger>
        <TooltipContent>{name}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default UserAvatar;
